module.exports = __webpack_public_path__ + "img/default.png";